import { Outlet } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

export default function MainLayout() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <SiteHeader />

      {/* This main block takes up remaining height */}
      <main className="flex-grow-1">
        <Outlet />
      </main>

      <SiteFooter />
    </div>
  );
}
